import { Table } from "react-bootstrap";
import React, { useContext, useEffect, useState } from "react";
import styles from "./SigningDocuments.module.scss";
import { observer } from "mobx-react-lite";
import { RootStoreContext } from "../../../stores/RootStore";
import BeatLoader from "react-spinners/BeatLoader";
import moment from "moment";
import { useSearchParams } from "react-router-dom";

const SellerDocuments: React.FC = observer(() => {
  const {
    financeStore: { getSellerDocuments, sellerDocuments },
    userStore: { info },
  } = useContext(RootStoreContext);

  const [loading, setLoading] = useState<boolean>(true);

  const [searchParams] = useSearchParams();

  const tab = searchParams.get("tab");

  useEffect(() => {
    setLoading(true);
    if (info && tab === "seller") {
      getSellerDocuments(
        info?.roles.includes("SuperAdmin") ? "" : "Seller"
      ).then(() => {
        setLoading(false);
      });
    }
  }, [getSellerDocuments, info, tab]);

  return (
    <>
      {loading ? (
        <div style={{ width: "fit-content", margin: "auto" }}>
          <BeatLoader color={"#f49100"} loading={loading} size={50} />
        </div>
      ) : (
        sellerDocuments &&
        sellerDocuments.map((item) => {
          return (
            <Table striped hover>
              <thead>
                <tr>
                  <th>{item.userName}</th>
                </tr>
                <tr>
                  <th>Документ</th>
                  <th>Дата создания</th>
                </tr>
              </thead>
              <tbody>
                {item.documents.map((item) => (
                  <tr>
                    <td>
                      <a
                        href={item.documentPath}
                        download={`${item.documentType}.pdf`}
                        target="_blank"
                      >
                        {item.documentType}
                      </a>
                    </td>
                    <td>
                      {" "}
                      {item.createDate
                        ? moment(item.createDate).format("DD.MM.YYYY")
                        : ""}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          );
        })
      )}
    </>
  );
});
export default SellerDocuments;
